import axios from 'axios';
import * as CONFIG from '../config/index';
import * as helper from './helper';

export const IDEA_SCORING_API_URL = `${CONFIG.API_URL}/idea-scoring`;

export const checkExist = async ideaId => {
  try {
    let checkExistRes = await axios.get(
      `${IDEA_SCORING_API_URL}/check-exist?ideaId=${ideaId}`
    );
    console.log(checkExistRes);
    return checkExistRes.data.data;
  } catch (e) {
    return true;
  }
};

export const getByIdeaId = async ideaId => {
  try {
    const result = await axios.get(
      `${IDEA_SCORING_API_URL}/get-by-idea?ideaId=${ideaId}`
    );
    return result.data.data;
  } catch (e) {
    helper.notifyError(e);
    return [];
  }
};

export const getByPeriod = async periodCode => {
  try {
    const result = await axios.get(
      `${IDEA_SCORING_API_URL}/get-by-period?period=${periodCode}`
    );
    return result.data.data;
  } catch (e) {
    helper.notifyError(e);
    return [];
  }
};

export default {
  checkExist,
  getByIdeaId,
  getByPeriod
};



// WEBPACK FOOTER //
// ./src/common/ideaScoring.js